/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Link } from '@atoms';
import { Form } from '@organisms';
import { COL_WITH_EXTRA } from '@constants';
import ROUTES from '@constants/routes';

import MinisiteSelect from '../MinisiteSelect';

const MinisiteField = React.forwardRef(
  (
    {
      initialMinisite,
      wrapperCol,
      disabled,
      onChange,
      onSearch,
      showAction,
      placeholder,
      queryVariables,
      value,
      ...props
    },
    ref,
  ) => {
    const [selectedMinisite, setSelectedMinisite] = React.useState(initialMinisite);

    const handleChange = (minisite) => {
      // eslint-disable-next-line no-unused-expressions
      onChange?.(minisite);
      setSelectedMinisite(minisite);
    };

    return (
      <>
        <Form.WithFieldValue name={props.name}>
          {(_value) => {
            if (!_value) {
              setSelectedMinisite(undefined);
            }
          }}
        </Form.WithFieldValue>
        <Form.ItemWithExtra
          wrapperCol={{ ...COL_WITH_EXTRA, ...wrapperCol }}
          extra={
            !!selectedMinisite && (
              <Link to={`/${ROUTES.MINISITES}/${selectedMinisite.id}`} target="_blank" rel="noopener noreferrer">
                Minisite setup
              </Link>
            )
          }
          {...props}
        >
          <MinisiteSelect
            value={value}
            ref={ref}
            onChange={handleChange}
            disabled={disabled}
            onSearch={onSearch}
            showAction={showAction}
            placeholder={placeholder}
            queryVariables={queryVariables}
          />
        </Form.ItemWithExtra>
      </>
    );
  },
);

export default MinisiteField;
